/*
 * ==========================================================================
 * SingRank - Meta Pixel content + lead events for RCS              v1.0.0
 * renovationcontractorsingapore.com
 * --------------------------------------------------------------------------
 * WHY THIS EXISTS
 * Measured 2026-09-02 with a real browser on a product page: the site's Meta
 * Pixel (1729244315076247) fires PageView and ViewContent with NO product
 * data at all - no content_ids, no content_type, no value. Meta therefore
 * cannot tell which package a visitor looked at, so catalogue (dynamic)
 * retargeting can never match, and Meta receives no Lead signal to optimise on.
 *
 * WHAT IT SENDS (only if the pixel is present on the page)
 *   1. Product pages     ViewContent { content_ids:[<Shopify product id>],
 *                                      content_type:'product', content_name,
 *                                      value, currency:'SGD' }
 *                        The id is the Shopify product id - the SAME id used
 *                        in our RCS-Meta-Catalogue.csv "id" column, so the
 *                        catalogue and the pixel finally agree.
 *   2. WhatsApp click    Lead   (any wa.me / whatsapp link or widget trigger)
 *   3. Contact form      Lead   (submit with email, phone or message)
 *   4. ai-deal.ai click  trackCustom 'ConsultClick'
 *
 * WHAT IT DOES NOT DO
 *   It does not init the pixel and does not fire PageView - the theme already
 *   does both. It never blocks or rewrites a click. If fbq is missing it stays
 *   silent. Note: the Shopify Facebook app pixel also fires a bare ViewContent;
 *   Meta will show two ViewContent events per product page until that app is
 *   set to "Data sharing: Maximum" - the one carrying content_ids is ours.
 *
 * DATA SOURCE
 *   window.ShopifyAnalytics.meta.product - present on every RCS product page
 *   (measured: id 8126687248700, variants[0].id 44456175337788, price in cents).
 *
 * SAFETY
 *   Guarded by window.__SR_META_CONTENT__. try/catch throughout. 1.2 s same-
 *   target debounce on clicks. No regular expressions and no escape sequences,
 *   by house rule.
 *
 * DEBUG (browser console)
 *   window.SR_META.state()   what was sent
 *   window.SR_META.test()    send a ViewContent for the current product again
 *
 * Maintained by SingRank. Created 2026-09-02.
 * ==========================================================================
 */
(function () {
  'use strict';

  if (window.__SR_META_CONTENT__) { return; }
  window.__SR_META_CONTENT__ = true;

  var CURRENCY = 'SGD';
  var WHATSAPP_MARKERS = ['wa.me', 'whatsapp.com', 'whatsapp:'];
  var OUTBOUND_HOSTS = ['ai-deal.ai', 'aideal.ai'];
  var STATE = { pixel: false, viewContent: null, leads: 0, consults: 0, errors: [] };
  var lastClick = { key: '', at: 0 };

  function low(s) { return String(s == null ? '' : s).toLowerCase(); }

  function contains(haystack, needles) {
    var h = low(haystack);
    if (!h) { return false; }
    for (var i = 0; i < needles.length; i++) {
      if (h.indexOf(needles[i]) > -1) { return true; }
    }
    return false;
  }

  function hasPixel() { return typeof window.fbq === 'function'; }

  function once(key) {
    var now = new Date().getTime();
    if (key === lastClick.key && (now - lastClick.at) < 1200) { return false; }
    lastClick.key = key; lastClick.at = now;
    return true;
  }

  function productInfo() {
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      var p = meta && meta.product;
      if (!p || !p.id) { return null; }
      var v = (p.variants && p.variants[0]) || {};
      var price = v.price ? (Number(v.price) / 100) : 0;
      var name = v.name || v.public_title || document.title || '';
      return { id: String(p.id), variant: v.id ? String(v.id) : '', name: String(name).substring(0, 100), value: price };
    } catch (e) { STATE.errors.push('productInfo: ' + e); return null; }
  }

  function sendViewContent() {
    var info = productInfo();
    if (!info || !hasPixel()) { return false; }
    try {
      var payload = { content_ids: [info.id], content_type: 'product', content_name: info.name, value: info.value, currency: CURRENCY };
      window.fbq('track', 'ViewContent', payload);
      STATE.viewContent = payload;
      return true;
    } catch (e) { STATE.errors.push('ViewContent: ' + e); return false; }
  }

  // The pixel script loads async; wait for it (up to ~10 s) before the first ViewContent.
  function whenPixelReady(fn, tries) {
    tries = tries || 0;
    if (hasPixel()) { STATE.pixel = true; fn(); return; }
    if (tries > 40) { return; }
    setTimeout(function () { whenPixelReady(fn, tries + 1); }, 250);
  }

  function isProductPage() {
    return (window.location.pathname || '').indexOf('/products/') === 0;
  }

  function lead(kind) {
    if (!hasPixel()) { return; }
    try { window.fbq('track', 'Lead', { content_name: kind }); STATE.leads = STATE.leads + 1; }
    catch (e) { STATE.errors.push('Lead: ' + e); }
  }

  // ---------- 1) product pages ----------
  if (isProductPage()) {
    whenPixelReady(sendViewContent);
  } else {
    whenPixelReady(function () {});
  }

  // ---------- 2) WhatsApp click + 4) ai-deal.ai click ----------
  document.addEventListener('click', function (ev) {
    try {
      var t = ev.target;
      var node = (t && t.closest) ? t.closest('a[href],[data-wa],[data-whatsapp],[class*="whatsapp"],[id*="whatsapp"],[aria-label*="whatsapp"]') : null;
      if (!node) { return; }
      var href = (node.getAttribute && node.getAttribute('href')) || '';
      var h = low(href);
      var cls = low((node.getAttribute && node.getAttribute('class')) || '') + ' ' + low((node.getAttribute && node.getAttribute('id')) || '') + ' ' + low((node.getAttribute && node.getAttribute('aria-label')) || '');
      if (contains(h, WHATSAPP_MARKERS) || cls.indexOf('whatsapp') > -1 || node.hasAttribute('data-wa') || node.hasAttribute('data-whatsapp')) {
        if (once('wa|' + (h || cls))) { lead('WhatsApp'); }
        return;
      }
      for (var i = 0; i < OUTBOUND_HOSTS.length; i++) {
        if (h.indexOf(OUTBOUND_HOSTS[i]) > -1) {
          if (once('out|' + h) && hasPixel()) {
            try { window.fbq('trackCustom', 'ConsultClick', { destination: OUTBOUND_HOSTS[i] }); STATE.consults = STATE.consults + 1; } catch (e) {}
          }
          return;
        }
      }
    } catch (e) { STATE.errors.push('click: ' + e); }
  }, true);

  // ---------- 3) contact form ----------
  document.addEventListener('submit', function (ev) {
    try {
      var f = ev.target;
      if (!f || f.tagName !== 'FORM') { return; }
      var q = function (sel) { var el = f.querySelector(sel); return el ? String(el.value || '').trim() : ''; };
      var email = q('[type="email"],[name*="email"],[name="contact[email]"]');
      var phone = q('[type="tel"],[name*="phone"],[name*="tel"]');
      var msg = q('textarea,[name*="message"],[name*="body"],[name="contact[body]"]');
      if (!email && !phone && !msg) { return; }
      lead('Form');
    } catch (e) { STATE.errors.push('submit: ' + e); }
  }, true);

  window.SR_META = {
    version: '1.0.0',
    state: function () { return STATE; },
    test: function () { return sendViewContent(); }
  };
})();
